<template>
  <div id="app" class="viewport">
    <svg-symbols name="icon"/>
    <svg-symbols name="button"/>

    <transition :name="transition">
      <div v-if="ready" :key="viewIndex" class="view">
        <router-view class="view__content slide--inner"/>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { SvgSymbols } from 'components/graphics'

export default {
  name: 'app',
  components: { SvgSymbols },

  beforeMount() {
    this.$store.dispatch('onLoad')
    this.viewIndex = this.$route.meta.index
  },

  data() {
    return {
      transition: 'slide--right',
      viewIndex: 0
    }
  },

  computed: mapState({
    ready: state => state.content.ready,
    title: state => state.content.title
  }),

  watch: {
    ready() {
      let {
        ogimage,
        ogtitle: title,
        ogsitename: siteName,
        ogdescription: description
      } = this.$store.state.content.meta

      this.$meta.defaults = { title, siteName, description, image: ogimage.crops.facebook }
    },
    '$route' (to, from) {
      let toIndex = to.meta.index
      let fromIndex = from.meta.index

      if (toIndex !== fromIndex) {
        this.transition = toIndex > fromIndex ? 'slide--left' : 'slide--right'
        this.viewIndex = toIndex
      }

      if (from) {
        this.$store.commit('moves/INCREMENT')
      }
    },
    title() {
      document.title = this.title
    }
  }
}
</script>

<style lang="scss">
@import '~sass/app';

.slide {
  &--left-enter-active,
  &--right-enter-active,
  &--left-leave-active,
  &--right-leave-active {
    .slide--inner,
    .header,
    .footer,
    & {
      transition: transform 525ms cb(io);
    }
  }

  &--left-enter {
    transform: translateX(100%);

    .slide--inner {
      transform: translateX(-90%);
    }

    .header,
    .footer {
      transform: translateX(-10%);
    }
  }

  &--right-enter {
    transform: translateX(-100%);

    .slide--inner {
      transform: translateX(90%);
    }

    .header,
    .footer {
      transform: translateX(10%);
    }
  }

  &--left-enter-to,
  &--right-enter-to,
  &--left-leave,
  &--right-leave {
    .slide--inner,
    .header,
    .footer,
    & {
      transform: translateX(0);
    }
  }

  &--left-leave-to {
    transform: translateX(-10%);

    .header,
    .footer {
      transform: translateX(10%);
    }
  }

  &--right-leave-to {
    transform: translateX(10%);

    .header, .footer {
      transform: translateX(-10%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?e1cc2e58